import comp from "./StudentResponseV2";
export default comp;
